import { connect } from 'react-redux';

import { close } from '../../actions/notifications';
import { Notification, INotificationProps } from '../../components/Notification';
import { IApplicationState, TThunkDispatch } from '../../types/redux';

type TNotificationStateProps = Pick<INotificationProps, 'notifications'>;
type TNotificationDispatchProps = Pick<INotificationProps, 'closeNotification'>;

function mapStateToProps(state: IApplicationState): TNotificationStateProps {
  return {
    notifications: state.notifications,
  };
}

function mapDispatchToProps(dispatch: TThunkDispatch): TNotificationDispatchProps {
  return {
    closeNotification: () => dispatch(close()),
  };
}

export const NotificationContainer = connect(mapStateToProps, mapDispatchToProps)(Notification);
